import React, {Component} from 'react'
import PropTypes from 'prop-types'
import format from 'date-fns/format';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import MenuItem from '@material-ui/core/MenuItem';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import { Link } from 'react-router-dom'
import BreadCrumbNav from '../BreadCrumbNav'
import { getUser,getUserSort,getComparator,stableSort } from '../../helpers';
import TableSortLabel from "@material-ui/core/TableSortLabel";

import './Version.css'
// function getUserSort() {
//   let userdata = {order: 'asc', orderBy: 'systemNo'};
//   let item = localStorage.getItem('setting-user-sort');
//   if (item && item !== 'undefined') {
//       let setting = JSON.parse(item);
//       if (setting && setting.order && setting.orderBy) {
//           userdata = setting;
//       }
//   }
//   return userdata;
// }

// function descendingComparator(a, b, orderBy) {
//   if (b[orderBy] < a[orderBy]) {
//     return -1;
//   }
//   if (b[orderBy] > a[orderBy]) {
//     return 1;
//   }
//   return 0;
// }

// function getComparator(order, orderBy) {
//   return order === 'desc'
//     ? (a, b) => descendingComparator(a, b, orderBy)
//     : (a, b) => -descendingComparator(a, b, orderBy);
// }

// function stableSort(array, comparator) {
//   const stabilizedThis = array.map((el, index) => [el, index]);
//   stabilizedThis.sort((a, b) => {
//     const order = comparator(a[0], b[0]);
//     if (order !== 0) return order;
//     return a[1] - b[1];
//   });
//   return stabilizedThis.map((el) => el[0]);
// }
class Version extends Component {
  constructor(props) {
    super(props);
    this.state = {
      offset: 0,
      limit: 10,
      date: null,
      order: getUserSort().order, 
      orderBy: getUserSort().orderBy,
    };
  }

  componentDidMount() {
    const { getVersions } = this.props
    const params = {
      offset: this.state.offset*this.state.limit,
      limit: this.state.limit,
      date: format(Date.now(), 'yyyy-MM-dd')
    };
    getVersions(params);
  }

  render() {
    const user = getUser()
    const { items, isFetching } = this.props
    let oldVersions = {};
    if (items && items.Hpa27OldVersionList && items.Hpa27OldVersionList.length > 0) {
      for(let i=0; i<items.Hpa27OldVersionList.length; i++){
        const key = items.Hpa27OldVersionList[i].os_info;
        if (!oldVersions[key]) {
          oldVersions[key] = [];
        }
        oldVersions[key].push(items.Hpa27OldVersionList[i]);
      }
      // console.log(oldVersions);
    }

    const handleSelectVersion = (event, os_info) => {
      if (oldVersions[os_info].length > 0) {
        const versions = oldVersions[os_info].filter(v => v.version_info === event.target.value);
        // console.log(event.target.value, versions);
        if (versions.length > 0) {
          window.location.href = versions[0].download_url;
        }
      }
    }

    const createSortHandler = (property) => () => {
      const isAsc = this.state.orderBy === property && this.state.order === 'asc';
      this.setState({
        order: isAsc ? 'desc' : 'asc',
        orderBy: property,
      }, () => {
        localStorage.setItem('setting-user-sort', JSON.stringify({ order: this.state.order, orderBy: this.state.orderBy }));
      });
    };


    return (
      <div className="content-container">
        {isFetching ? <div className='loading'>お待ちください．．．</div>
          :<> 
          <BreadCrumbNav screenName="データ収集ソフト"></BreadCrumbNav>
          <div className="version-loginname">ログイン名：{user.username}</div>
          <TableContainer className="version-table" component={Paper}>
          <Table aria-label="simple table">
            <TableHead>
              <TableRow>
                {/* <TableCell align="center" style={{ width: 300 }}>OS</TableCell> */}
                <TableCell 
                  key="os_info"
                  align="center" 
                  sortDirection={this.state.orderBy === "sort_num" ? this.state.order : false}
                  style={{ minWidth: 300 }}
                >              
                  <TableSortLabel
                    direction={this.state.orderBy === "sort_num" ? this.state.order : 'asc'}
                    // onClick={createSortHandler("os_info")}
                    onClick={createSortHandler("sort_num")}
                  >
                    OS
                    {this.state.orderBy === "sort_num" ? (
                      <span className="visuallyHidden">
                        {this.state.order === 'desc' ? 'sorted descending' : 'sorted ascending'}
                      </span>
                    ) : null}
                  </TableSortLabel>  
                </TableCell>
                {/* <TableCell align="center" style={{ minWidth: 200 }}>HPA-27の最新バージョン</TableCell> */}
                <TableCell 
                  key="version_info"
                  align="center" 
                  sortDirection={this.state.orderBy === "version_info" ? this.state.order : false}
                  style={{ minWidth: 200 }}
                >              
                  <TableSortLabel
                    direction={this.state.orderBy === "version_info" ? this.state.order : 'asc'}
                    onClick={createSortHandler("version_info")}
                  >
                    HPA-27の最新バージョン
                    {this.state.orderBy === "version_info" ? (
                      <span className="visuallyHidden">
                        {this.state.order === 'desc' ? 'sorted descending' : 'sorted ascending'}
                      </span>
                    ) : null}
                  </TableSortLabel>  
                </TableCell>
                <TableCell align="center" style={{ minWidth: 200 }}>旧バージョン</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
            {items && stableSort(items.Hpa27VersionList || [], getComparator(this.state.order, this.state.orderBy))
              .map((item, index) => (
                <TableRow key={index}>
                  <TableCell align="center" component="th" scope="row">{item.os_info}</TableCell>
                  <TableCell align="center">
                    <Link to={{ pathname: item.download_url }} target="_Self">
                      Version {item.version_info}
                    </Link>
                  </TableCell>
                  <TableCell align="center">
                    <FormControl variant="outlined" className="old-versions">
                      <Select
                        name={"name"}
                        value="-1"
                        onChange={(event) => handleSelectVersion(event, item.os_info)}
                      >
                        <MenuItem value="-1"><em>旧バージョンを選択</em></MenuItem>
                        {oldVersions && oldVersions[item.os_info] && oldVersions[item.os_info].map((version, index) => (
                          <MenuItem key={version.version_info} value={version.version_info}>Version {version.version_info}</MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
        </>
        }
      </div>
    );
  }
}

Version.propTypes = {
  getVersions: PropTypes.func.isRequired,
};

export default Version;